/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Teilleistungsschwaechensonst1Inputs */

const de__field_teilleistungsschwaechensonst1 = /** @type {(inputs: _Field_Teilleistungsschwaechensonst1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sonstige Teilleistungsschwächen`)
};

/**

* @param {_Field_Teilleistungsschwaechensonst1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_teilleistungsschwaechensonst1 = /** @type {((inputs?: _Field_Teilleistungsschwaechensonst1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Teilleistungsschwaechensonst1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_teilleistungsschwaechensonst1(inputs)
});
export { _field_teilleistungsschwaechensonst1 as "_field_teilleistungsschwaechenSonst" }